import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/flightFares', request)
}

export {get}
